import {
    ICBOService,
    ICBOServiceCalculateScenarioOptions,
    ICBOServiceRequest,
    ICBOServiceResponse
} from "./CBOServices.IF";
import axios from 'axios';
import {PAEnvironment} from "../PA.Core/PAEnvironment";

export class CBOService
    implements ICBOService {


    CalculateCBO(wbCBOId: number, opts?: ICBOServiceCalculateScenarioOptions): Promise<ICBOServiceResponse> {
        let aCalculationRequest: ICBOServiceRequest = {
            RequestType: "Calculate",
            RequestOptions: opts,
            wbCBOId: wbCBOId
        }
        return this.makeRequest(aCalculationRequest);
    }

    GetCBOStatus(wbCBOId: number, opts?: any): Promise<ICBOServiceResponse> {
        let aCalculationRequest: ICBOServiceRequest = {
            RequestType: "GetStatus",
            RequestOptions: opts,
            wbCBOId: wbCBOId
        }
        return this.makeRequest(aCalculationRequest);
    }

    StopCBO(wbCBOId: number, opts?: any): Promise<ICBOServiceResponse> {
        let aCalculationRequest: ICBOServiceRequest = {
            RequestType: "Stop",
            RequestOptions: opts,
            wbCBOId: wbCBOId
        }
        return this.makeRequest(aCalculationRequest);
    }

    private makeRequest(aRequst: ICBOServiceRequest) : Promise<ICBOServiceResponse> {
        return new Promise<ICBOServiceResponse>((resolve, error) => {
            let sEndPoint = <string>PAEnvironment.getValue(PAEnvironment.Network_URL_Base, "/");
            if (sEndPoint.endsWith('/')) {
                sEndPoint += 'cboService';
            } else {
                sEndPoint += '/cboService';
            }

            axios.post(sEndPoint, {data: {request: aRequst}})
                .then((resp: any) => {
                    let responseData = resp.data;
                    resolve(responseData);
                })
                .catch((err) => {
                    error(err);
                })
        })
    }
}